import { combineReducers, createReducer, type UnknownAction } from '@reduxjs/toolkit';

import {
  clearVerifyFitmentRequest,
  garageCleanupRequested,
  removalFromGarageRequested,
  replaceVerifyFitmentVehicleValue,
  setVerifyFitmentFacets,
  setVerifyFitmentProduct,
  setVerifyFitmentProductId,
  vehicleDiscardingRequested,
  vehicleSelected,
} from 'Core/actions/fitmentSearch/index';
import { FacetCollection } from 'Models';
import productConfig from 'Models/uiConfig/productConfig';
import type { ServerModel } from 'Modules/serverApi/types';

import { fixRequestDueToResponse, getInitialVehicleSelection, updateVehicleSelection } from './common';

const verifyFitmentReducer = combineReducers({
  productId: createReducer(
    productConfig.localItemId ? Number(productConfig.localItemId) : null,
    (builder) => {
      builder.addCase(setVerifyFitmentProductId, (_state, { payload }) => payload);
    },
  ),
  request: combineReducers({
    selection: createReducer(getInitialVehicleSelection(), (builder) => {
      builder
        .addCase(clearVerifyFitmentRequest, () => [])
        .addCase(garageCleanupRequested, () => [])
        .addCase(vehicleDiscardingRequested, () => [])
        .addCase(removalFromGarageRequested, (state, { meta }) => (meta.wasSelected ? [] : state))
        .addCase(replaceVerifyFitmentVehicleValue, (state, { payload, meta: { fitmentFields } }) =>
          updateVehicleSelection(state, payload, fitmentFields),
        )
        .addCase(vehicleSelected, (_state, { payload: { selection } }) => selection);
    }),
  }),
  response: combineReducers({
    facets: createReducer(new FacetCollection(), (builder) => {
      builder.addCase(setVerifyFitmentFacets, (_state, { payload }) => payload);
    }),
    product: createReducer<ServerModel.SearchItem | null>(null, (builder) => {
      builder.addCase(setVerifyFitmentProduct, (_state, { payload }) => payload);
    }),
  }),
});

type VerifyFitmentState = ReturnType<typeof verifyFitmentReducer>;

const verifyFitment = (state: VerifyFitmentState | undefined, action: UnknownAction): VerifyFitmentState =>
  verifyFitmentReducer(
    fixRequestDueToResponse(state, replaceVerifyFitmentVehicleValue.match(action)),
    action,
  );

export default verifyFitment;
